import api from 'js/api'
export const deleteAccount = userid => {
  return api('DELETE', 'v2/accounts/account_delete', {
    userid,
  }).then(res => {
    return res.response
  })
}
